import { useState } from 'react'
import { VideoData } from '../../../interfaces'
import MobileOverlay from './mobile/MobileOverlay'
import WebOverlay from './web/WebOverlay'

const CustomOverlay = ({
  videoMetadata,
  scheduledTime,
}: {
  videoMetadata: VideoData
  scheduledTime: Date
}): JSX.Element => {
  const [useMobilePlayer] = useState(isMobile())
  // const [ownsNFT] = useAtom(ownsNFTAtom)

  return useMobilePlayer ? (
    <MobileOverlay videoMetadata={videoMetadata} scheduledTime={scheduledTime} />
  ) : (
    <>
      <WebOverlay videoMetadata={videoMetadata} scheduledTime={scheduledTime} />
      {/* <WebProgressBar videoElementRef={videoElementRef} trailermode={!ownsNFT} /> */}
    </>
  )
}

export default CustomOverlay

function isMobile() {
  return navigator.maxTouchPoints != 0
}
